import { StickyOfferModel } from 'models';

export const adaptStickyOffer = (response: any): StickyOfferModel => {
  if (!hasStickyBar(response)) {
    return null;
  }

  const stickyBar = response.data.propertyOffers.stickyBar;

  return {
    price: stickyBar.displayPrice,
    qualifier: stickyBar.qualifier,
    subText: stickyBar.subText,
    buttonText: stickyBar.stickyButton?.text,
    targetRef: stickyBar.stickyButton?.targetRef,
    prefix: stickyBar.price?.leadingCaption,
    legalDisclaimer: stickyBar.price?.disclaimer?.value,
  } as StickyOfferModel;
};

export const hasStickyBar = (response: any) => Boolean(response?.data?.propertyOffers?.stickyBar);
